import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-12px text-gray-lp-300 mt-5" }
const _hoisted_4 = { class: "text-10px text-gray-lp-800" }
const _hoisted_5 = { class: "text-12px" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Diskon Agen ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_highlight_loading = _resolveComponent("highlight-loading")!
  const _component_card = _resolveComponent("card")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_highlight_loading, { key: 0 }))
    : (_openBlock(), _createBlock(_component_card, {
        key: 1,
        isShadow: false,
        customClass: `border ${
      _ctx.firstRender || !_ctx.product.statusActive || _ctx.isEmbargo || _ctx.product.isEmbargo ? 'border-gray-lp-400 cursor-pointer' : `${_ctx.product.statusSelect ? 'bg-pink-lp-500 border border-red-lp-1500 cursor-pointer' : 'cursor-pointer border border-purple-lp-800'}`
    }`,
        class: "relative px-5",
        style: {"height":"210px","width":"100%"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.firstRender && !_ctx.isDisabled && _ctx.product.statusActive && (!_ctx.isEmbargo && !_ctx.product.isEmbargo) ? _ctx.setActive() : () => {})),
        isDisabled: _ctx.isDisabled || !_ctx.product.statusActive || _ctx.isEmbargo || _ctx.product.isEmbargo
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("img", {
              class: "text-gray-lp-600 pt-3",
              src: require(`@/app/ui/assets/svg/product-logo/${_ctx.product.icon}-${_ctx.product.statusCard && _ctx.product.statusActive && (!_ctx.isEmbargo && !_ctx.product.isEmbargo) ? 'active' : 'inactive'}.svg`),
              alt: "bosspack-card",
              width: "100",
              height: "18"
            }, null, 8, ["src"]),
            _withDirectives(_createVNode("div", {
              class: `text-10px font-semibold mt-2 text-center`,
              style: `color: ${_ctx.isEmbargo || _ctx.product.isEmbargo ? '' : _ctx.product.color}`
            }, null, 4), [
              [_directive_sanitize_html, _ctx.product.motto]
            ]),
            _createVNode("div", _hoisted_2, [
              _createVNode("p", _hoisted_3, _toDisplayString(_ctx.product.statusCard && (!_ctx.isEmbargo && !_ctx.product.isEmbargo) ? _ctx.hideKgs ? _ctx.product.price?.toString()?.replace(/\/(?:10kg awal|30kg awal|kg)/g, '') : _ctx.product.price : _ctx.version === 'v1' ? 'Rp-' : _ctx.isEmbargo || _ctx.product.isEmbargo ? _ctx.$t("booking.productPoster.shippingEmbargo") : _ctx.$t("booking.productPoster.notAvailable")), 1),
              _createVNode("p", _hoisted_4, _toDisplayString(_ctx.product.statusCard && (!_ctx.isEmbargo && !_ctx.product.isEmbargo) ? _ctx.product.sla : _ctx.version === 'v1' ? '-': ''), 1)
            ])
          ]),
          _createVNode("div", {
            class: "absolute bottom-0 left-0 top-12 w-full rounded-b-md text-center py-1",
            style: `
          background-color: ${_ctx.isEmbargo || _ctx.product.isEmbargo ? '#a7a8aa' : _ctx.product.color}; 
          background: linear-gradient(180deg, ${_ctx.isEmbargo || _ctx.product.isEmbargo ? '#ffffff' : _ctx.product.footer.firstColor} -109.09%, ${_ctx.isEmbargo || _ctx.product.isEmbargo ? '#a7a8aa' : _ctx.product.footer.secondColor} 100%);
          color: ${_ctx.isEmbargo || _ctx.product.isEmbargo ? '#fff' : _ctx.product.icon === 'sameday' ? '#F09035' : 'white'};
          margin-top: 100px;
        `
          }, [
            _createVNode("p", _hoisted_5, [
              _hoisted_6,
              _createVNode("strong", null, _toDisplayString(_ctx.product.statusCard && (!_ctx.isEmbargo && !_ctx.product.isEmbargo)  ? _ctx.product.discountAgentPrecentage : "-"), 1)
            ]),
            _createVNode("strong", null, _toDisplayString(_ctx.product.statusCard && (!_ctx.isEmbargo && !_ctx.product.isEmbargo) ? _ctx.hideKgs ? _ctx.product.discountAgentNominal?.replace(/\/(?:10kg awal|30kg awal|kg)/g, '') : _ctx.product.discountAgentNominal : _ctx.version === 'v1'? "Rp-": "-"), 1)
          ], 4)
        ]),
        _: 1
      }, 8, ["customClass", "isDisabled"]))
}